import { Component, Input } from '@angular/core';
import { ColumnComponent } from '@progress/kendo-angular-grid';
import { ColumnOptions } from '../../models';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-filter-cell',
  templateUrl: './filter-cell.component.html',
  styleUrl: './filter-cell.component.scss',
})
export class FilterCellComponent {
  @Input()
  gridColumn!: ColumnComponent;

  @Input()
  column!: ColumnOptions;

  @Input()
  filter!: CompositeFilterDescriptor;
}
